import {
    useState,
    useContext,
    useEffect,
    forwardRef,
    useCallback,
} from "react";
import PrintIcon from "@mui/icons-material/Print";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import OrderViewModal from '../modals/OrderViewModal';
import CloseIcon from "@mui/icons-material/Close";
import QualityInspectionReport from "./qualityrepo";
import { IOSSwitch } from "../../commonjs/TableFunc";
import moment from "moment";
import { axiosInstances, getLookupData, getOrderAllLakVal, inspection_order_delete, order_issue_list, setOrderGeneric } from "../../constant/url";
import { AccessContext } from "../../constant/accessContext";
import axios from "axios";
import useAxiosInterceptor from "../Interceptors/axios";
import { NavLink } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ModuleTools from "../modals/ModuleTools";
import statusPercentage from "../../commonjs/StatusPercentage";
import Brazing from "../../assets/img/appIcons/Brazing.png";
import ce_cl from "../../assets/img/appIcons/br-ce.png";
import brazing_cl from "../../assets/img/appIcons/br-braz.png";
import paint_cl from "../../assets/img/appIcons/br-paint.png";
import quality from "../../assets/img/appIcons/Qualitym1.png";
import quality_cl from "../../assets/img/appIcons/Qualityqua.png";
import { handleFindCoverDetailLookup_arr, handleFindLookup_arr } from "../../commonjs/CommonFun";
import Painting from "../../assets/img/appIcons/Painting.png";
import CEx from "../../assets/img/appIcons/Coil Expansion.png";
import disp_cl from "../../assets/img/appIcons/br-disp.png";
import Disp from "../../assets/img/appIcons/Dispatch.png";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});




function Quality() {
    useAxiosInterceptor(axiosInstances)
    const accessModuleList = useContext(AccessContext).accessModuleList;
    const [openOrderView, setOpenOrderView] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(0);
    const [isEdit, setIsEdit] = useState(false);
    const [orderList, setOrderList] = useState([]);
    const [animeShow, setAnimeShow] = useState(false);
    const access = useContext(AccessContext).authID;
    const [openStatusCnf, setOpenStatusCnf] = useState(false);
    const [selEvent, setSelEvent] = useState({
        target: { name: "", checked: null },
    });
    const handleCloseStatus = (response) => {
        if (response === "yes") {
            handleNested(selectedRowId, {
                target: { name: "quality_status", checked: true },
            });
        }
        setOpenStatusCnf(false);
    };

    const [lookUpList, setLookupList] = useState([]);





    function handleGetLookup() {
        var bodyFormData = new FormData();
        bodyFormData.append("authId", access);

        axios({
            method: "post",
            url: getLookupData,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                //handle success
                const res_data = response.data;
                if (res_data.status_code === 200) {
                    setLookupList(res_data);
                } else {
                    toast(res_data.status_msg, "error");
                }
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }

    useEffect(() => {
        handleGetLookup();
    }, []);


    async function evaluateInspection(description, serialno, inspectionData) {
        if (Array.isArray(inspectionData) && inspectionData.length > 0) {
            const matchedItem = inspectionData.find(item => {
                return item.measurement === description && item.order_serial_no === serialno;
            });
            if (matchedItem) {
                return {
                    status: matchedItem.status || ' ',
                    remarks: matchedItem.remarks || 'No remarks',
                    order_serial_no: matchedItem.order_serial_no,
                };
            }
        }
    }

    const [sectionStatus, setSectionStatus] = useState([]);
    console.log(sectionStatus);



    const getLeadTime = (coilReadyDate, orderDate) => {
        if (!coilReadyDate || !orderDate) return "--";

        return moment(coilReadyDate).diff(moment(orderDate, "DD/MM/YYYY"), "days");
    };



    // const handleOrderList = async () => {
    //     const bodyFormData = new FormData();
    //     bodyFormData.append("authId", access);
    //     bodyFormData.append("pageType", "qualityStatus");

    //     try {
    //         const response = await axiosInstances({
    //             method: "post",
    //             url: getOrderAllLakVal,
    //             data: bodyFormData,
    //             headers: { "Content-Type": "multipart/form-data" },
    //         });

    //         const res_data = response.data;

    //         if (res_data.status_code === 101) {
    //             toast("API Authentication failed. Login again.");
    //             return;
    //         }

    //         if (res_data.status_code === 200) {
    //             const ret_data_cd = res_data.data_orders;
    //             const newOrderList = ret_data_cd.map((item) => {
    //                 if (!item) return;

    //                 const originalId = item.order_id;
    //                 const baseOrderId = item.order_id.replace(/\D+$/, '');
    //                 // Serial numbers of this variant order (as array)
    //                 const serialNoList = item.serial_no
    //                     ? item.serial_no.split(',').map(s => s.trim())
    //                     : null;


    //                 const baseOrder = ret_data_cd.find(o => o.order_id === baseOrderId);
    //                 const baseInspections = baseOrder?.quality_inspection || [];

    //                 let filteredInspections = baseInspections;
    //                 if (serialNoList && serialNoList.length > 0) {
    //                     filteredInspections = baseInspections.filter(ins => serialNoList.includes(String(ins.order_serial_no)));
    //                 }

    //                 console.log(filteredInspections)


    //                 const updatedItems = filteredInspections.map(item => ({
    //                     ...item,
    //                     orderId: originalId,
    //                 }));


    //                 console.log(baseOrderId);
    //                 console.log(serialNoList);

    //                 const leadTime = getLeadTime(item.coil_ready_at, item.order_date);
    //                 let ordersta = "";

    //                 if (
    //                     item.ca_status === "true" &&
    //                     item.ce_status !== "true" &&
    //                     item.brazing_status !== "true" &&
    //                     item.pp_status !== "true"
    //                 ) {
    //                     ordersta = (item.quality === "1" || item.priority === "true") ? CEx : ce_cl;

    //                 } else if (
    //                     item.ca_status === "true" &&
    //                     item.ce_status === "true" &&
    //                     item.brazing_status !== "true" &&
    //                     item.pp_status !== "true"
    //                 ) {
    //                     ordersta = (item.quality === "1" || item.priority === "true") ? Brazing : brazing_cl;

    //                 } else if (
    //                     item.ca_status === "true" &&
    //                     item.ce_status === "true" &&
    //                     item.brazing_status === "true" &&
    //                     item.pp_status !== "true"
    //                 ) {
    //                     ordersta = (item.quality === "1" || item.priority === "true") ? Painting : paint_cl;
    //                 }
    //                 else if (
    //                     item.ca_status === "true" &&
    //                     item.ce_status === "true" &&
    //                     item.brazing_status === "true" &&
    //                     item.pp_status === "true"
    //                 ) {
    //                     if (item.quality == "1" || item.priority == "true") {
    //                         ordersta = quality_cl;
    //                     } else if (item.quality == "1" || item.priority != "true") {
    //                         ordersta = disp_cl;
    //                     }
    //                     else {
    //                         ordersta = disp_cl;
    //                     }
    //                 }

    //                 // else if (
    //                 //     item.ca_status === "true" &&
    //                 //     item.ce_status === "true" &&
    //                 //     item.brazing_status === "true" &&
    //                 //     item.pp_status === "true"
    //                 // ) {
    //                 //      if (item.quality != "1" || item.priority != "true") {
    //                 //         ordersta = Disp;
    //                 //     }
    //                 // }

    //                 return {
    //                     ...item,
    //                     status: statusPercentage(item),
    //                     lead_time: leadTime,
    //                     orstatus: ordersta,
    //                 };
    //             });

    //             const sortedOrders = [...newOrderList].sort((a, b) => {
    //                 const aFirstPriority = a.quality === '1' && a.priority !== "true";
    //                 const bFirstPriority = b.quality === '1' && b.priority !== "true";
    //                 if (aFirstPriority && !bFirstPriority) return -1;
    //                 if (!aFirstPriority && bFirstPriority) return 1;

    //                 const aSecond = a.priority === "true" && a.tcutting_status === "true" && a.finpunch_status === "true";
    //                 const bSecond = b.priority === "true" && b.tcutting_status === "true" && b.finpunch_status === "true";
    //                 if (aSecond && !bSecond) return -1;
    //                 if (!aSecond && bSecond) return 1;

    //                 const aThird = a.quality === '1' && aSecond;
    //                 const bThird = b.quality === '1' && bSecond;
    //                 if (aThird && !bThird) return -1;
    //                 if (!aThird && bThird) return 1;

    //                 return (Number(b.status) || 0) - (Number(a.status) || 0);
    //             });

    //             const allSectionStatuses = [];

    //             for (const order of sortedOrders) {
    //                 const inspections = order.quality_inspection;

    //                 if (!inspections || !Array.isArray(inspections)) continue;

    //                 const serialTracker = new Set();


    //                 for (const coilno of inspections) {
    //                     const serialno = coilno.order_serial_no;
    //                     const uniqueKey = `${order.order_id}-${serialno}`;
    //                     if (serialTracker.has(uniqueKey)) continue;
    //                     serialTracker.add(uniqueKey);


    //                     const evaluateSection = (statuses) =>
    //                         statuses.every(status => {
    //                             // if (typeof status !== 'string' || !status.trim()) return false;
    //                             const normalized = status?.toLowerCase();
    //                             console.log(normalized)
    //                             return ['ok', 'n/a', 'issue corrected'].includes(normalized);
    //                         }) ? 'Pass' : '';


    //                     const [
    //                         lengthEval,
    //                         heightEval,
    //                         rowsEval,
    //                         endplateMaterialEval,
    //                         endplateModelEval,
    //                         endplateOrientationEval,
    //                         coverDetailEval,

    //                         pipeTypeEval,
    //                         straightPipeEval,
    //                         singlePipeEval,
    //                         crossPipeEval,
    //                         otherPipeEval,

    //                         finsPerInchEval,
    //                         finThicknessEval,

    //                         afterCoilEval,

    //                         circuitEval,
    //                         feedingEval,
    //                         liquidLineEval,
    //                         dischargeLineEval,
    //                         afterBrazingEval,

    //                         paintTypeEval,
    //                         packingTypeEval,
    //                     ] = await Promise.all([
    //                         evaluateInspection('Length', serialno, inspections),
    //                         evaluateInspection('Height', serialno, inspections),
    //                         evaluateInspection('Rows', serialno, inspections),
    //                         evaluateInspection('Endplate Material', serialno, inspections),
    //                         evaluateInspection('Endplate Model', serialno, inspections),
    //                         evaluateInspection('Endplate Orientation', serialno, inspections),
    //                         evaluateInspection('Cover Detail', serialno, inspections),

    //                         evaluateInspection('Pipe Type', serialno, inspections),
    //                         evaluateInspection('Straight Pipe', serialno, inspections),
    //                         evaluateInspection('Single Pipe', serialno, inspections),
    //                         evaluateInspection('Cross Pipe', serialno, inspections),
    //                         evaluateInspection('Other Pipe', serialno, inspections),

    //                         evaluateInspection('Fins Per Inch', serialno, inspections),
    //                         evaluateInspection('Fin Thickness', serialno, inspections),

    //                         evaluateInspection('After Coil Assembly (Drawing / Sample)', serialno, inspections),

    //                         evaluateInspection('Circuit', serialno, inspections),
    //                         evaluateInspection('Feeding', serialno, inspections),
    //                         evaluateInspection('Liquid Line', serialno, inspections),
    //                         evaluateInspection('Discharge Line', serialno, inspections),
    //                         evaluateInspection('After Brazing (Drawing / Sample)', serialno, inspections),

    //                         evaluateInspection('Paint Type', serialno, inspections),
    //                         evaluateInspection('Packing Type', serialno, inspections),
    //                     ]);

    //                     const endplateFinalStatus = evaluateSection([
    //                         lengthEval?.status,
    //                         heightEval?.status,
    //                         rowsEval?.status,
    //                         endplateMaterialEval?.status,
    //                         endplateModelEval?.status,
    //                         endplateOrientationEval?.status,
    //                         coverDetailEval?.status,
    //                     ]);


    //                     const pipeFinalStatus = evaluateSection([
    //                         pipeTypeEval?.status,
    //                         straightPipeEval?.status,
    //                         singlePipeEval?.status,
    //                         crossPipeEval?.status,
    //                         otherPipeEval?.status,
    //                     ]);

    //                     const finFinalStatus = evaluateSection([
    //                         finsPerInchEval?.status,
    //                         finThicknessEval?.status,
    //                     ]);

    //                     const assemblyFinalStatus = evaluateSection([
    //                         afterCoilEval?.status,
    //                     ]);

    //                     const brazingFinalStatus = evaluateSection([
    //                         circuitEval?.status,
    //                         feedingEval?.status,
    //                         liquidLineEval?.status,
    //                         dischargeLineEval?.status,
    //                         afterBrazingEval?.status,
    //                     ]);

    //                     const packingFinalStatus = evaluateSection([
    //                         paintTypeEval?.status,
    //                         packingTypeEval?.status,
    //                     ]);

    //                     allSectionStatuses.push({
    //                         orderId: order.order_id,
    //                         serialno: serialno,
    //                         Endplate: endplateFinalStatus,
    //                         Pipe: pipeFinalStatus,
    //                         Fins: finFinalStatus,
    //                         Assembly: assemblyFinalStatus,
    //                         Brazing: brazingFinalStatus,
    //                         Packing: packingFinalStatus,
    //                     });
    //                 }
    //             }

    //             setSectionStatus(allSectionStatuses);
    //             setOrderList(sortedOrders);
    //         } else {
    //             console.log(res_data.status_msg);
    //         }

    //     } catch (error) {
    //         console.error("Error fetching order list:", error);
    //     }
    // };

    // const [loading, setLoading] = useState("");

    const handleOrderList = async () => {

        const bodyFormData = new FormData();
        bodyFormData.append("authId", access);
        bodyFormData.append("pageType", "qualityStatus");

        try {
            const response = await axiosInstances({
                method: "post",
                url: getOrderAllLakVal,
                data: bodyFormData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            const res_data = response.data;

            if (res_data.status_code === 101) {
                //  setLoading(false)
                toast("API Authentication failed. Login again.");
                return;
            }

            if (res_data.status_code !== 200) {
                //  setLoading(false)
                console.log(res_data.status_msg);
                return;
            }

            const ret_data_cd = res_data.data_orders || [];

            const newOrderList = ret_data_cd.map((item) => {


                if (!item) return null;

                const originalId = item.order_id ;
                console.log(originalId)
                const baseOrderId = originalId;

                const serialNoList = item.serial_no?.trim()
                    ? item.serial_no.split(',').map(s => s.trim())
                    : item?.quality_inspection?.order_serial_no
                        ? [item?.quality_inspection?.order_serial_no.trim()]
                        : [];


                let baseInspections = [];


                if (baseOrderId == originalId) {
                    baseInspections = item.quality_inspection || [];
                } else {
                    const baseOrder = ret_data_cd.find(o => o.order_id === baseOrderId);
                    baseInspections = baseOrder?.quality_inspection || [];
                }

                const filteredInspections = serialNoList.length > 0
                    ? baseInspections.filter(ins => serialNoList.includes(String(ins.order_serial_no)))
                    : baseInspections;

                const updatedItems = filteredInspections.map(ins => ({
                    ...ins,
                    orderId: originalId,
                }));

                const leadTime = getLeadTime(item.coil_ready_at, item.order_date);

                let ordersta = "";
                // const isHighPriority = item.quality === "1" || item.priority === "true";

                // if (item.ca_status === "true" && item.ce_status !== "true") {
                //     ordersta = isHighPriority ? CEx : ce_cl;
                // } else if (item.ce_status === "true" && item.brazing_status !== "true") {
                //     ordersta = isHighPriority ? Brazing : brazing_cl;
                // } else if (item.brazing_status === "true" && item.pp_status !== "true") {
                //     ordersta = isHighPriority ? Painting : paint_cl;
                // } else if (item.pp_status === "true") {
                //     ordersta = isHighPriority ? quality_cl : disp_cl;
                // }

                const isNonHighPriority = item.quality !== "1" || item.priority === "true";

                if (item.ca_status === "true" && item.ce_status !== "true") {
                    ordersta = isNonHighPriority ? ce_cl : CEx;
                } else if (item.ce_status === "true" && item.brazing_status !== "true") {
                    ordersta = isNonHighPriority ? brazing_cl : Brazing;
                } else if (item.brazing_status === "true" && item.pp_status !== "true") {
                    ordersta = isNonHighPriority ? paint_cl : Painting;
                } else if (item.pp_status === "true") {
                    ordersta = isNonHighPriority ? disp_cl : quality_cl;
                }

                return {
                    ...item,
                    status: statusPercentage(item),
                    lead_time: leadTime,
                    orstatus: ordersta,
                    quality_inspection: updatedItems
                };
            }).filter(Boolean);


            const sortedOrders = newOrderList.sort((a, b) => {
                const priorityA = a.quality === '1' && a.priority !== "true";
                const priorityB = b.quality === '1' && b.priority !== "true";
                if (priorityA !== priorityB) return priorityA ? -1 : 1;

                const secondA = a.priority === "true" && a.tcutting_status === "true" && a.finpunch_status === "true";
                const secondB = b.priority === "true" && b.tcutting_status === "true" && b.finpunch_status === "true";
                if (secondA !== secondB) return secondA ? -1 : 1;

                const thirdA = a.quality === '1' && secondA;
                const thirdB = b.quality === '1' && secondB;
                if (thirdA !== thirdB) return thirdA ? -1 : 1;

                return (Number(b.status) || 0) - (Number(a.status) || 0);
            });


            const allSectionStatuses = [];

            for (const order of sortedOrders) {
                const inspections = order.quality_inspection;
                if (!Array.isArray(inspections)) continue;

                const serialTracker = new Set();

                for (const ins of inspections) {
                    const serialno = ins.order_serial_no;
                    const uniqueKey = `${order.order_id}-${serialno}`;
                    if (serialTracker.has(uniqueKey)) continue;
                    serialTracker.add(uniqueKey);

                    // const evaluateSection = (statuses) =>
                    //     statuses.every(status =>
                    //         ['ok', 'n/a', 'issue corrected'].includes((status || '').toLowerCase())
                    //     ) ? 'Pass' : '';


                    const evaluateSection = (statuses) => {
                        const normalized = statuses.map(status => (status || '').toLowerCase());

                        if (normalized.includes('not ok')) {
                            return 'Fail';
                        }

                        return normalized.every(status =>
                            ['ok', 'n/a', 'issue corrected'].includes(status)
                        ) ? 'Pass' : '';
                    };



                    const evaluations = await Promise.all([
                        evaluateInspection('Length', serialno, inspections),
                        evaluateInspection('Height', serialno, inspections),
                        evaluateInspection('Rows', serialno, inspections),
                        evaluateInspection('Endplate Material', serialno, inspections),
                        evaluateInspection('Endplate Model', serialno, inspections),
                        evaluateInspection('Endplate Orientation', serialno, inspections),
                        evaluateInspection('Cover Detail', serialno, inspections),

                        evaluateInspection('Pipe Type', serialno, inspections),
                        evaluateInspection('Straight Pipe', serialno, inspections),
                        evaluateInspection('Single Pipe', serialno, inspections),
                        evaluateInspection('Cross Pipe', serialno, inspections),
                        evaluateInspection('Other Pipe', serialno, inspections),

                        evaluateInspection('Fins Per Inch', serialno, inspections),
                        evaluateInspection('Fin Thickness', serialno, inspections),

                        evaluateInspection('After Coil Assembly (Drawing / Sample)', serialno, inspections),

                        evaluateInspection('Circuit', serialno, inspections),
                        evaluateInspection('Feeding', serialno, inspections),
                        evaluateInspection('Liquid Line', serialno, inspections),
                        evaluateInspection('Discharge Line', serialno, inspections),
                        evaluateInspection('After Brazing (Drawing / Sample)', serialno, inspections),

                        evaluateInspection('Paint Type', serialno, inspections),
                        evaluateInspection('Packing Type', serialno, inspections),
                    ]);

                    const [
                        lengthEval, heightEval, rowsEval,
                        endplateMaterialEval, endplateModelEval, endplateOrientationEval, coverDetailEval,

                        pipeTypeEval, straightPipeEval, singlePipeEval, crossPipeEval, otherPipeEval,

                        finsPerInchEval, finThicknessEval,

                        afterCoilEval,

                        circuitEval, feedingEval, liquidLineEval, dischargeLineEval, afterBrazingEval,

                        paintTypeEval, packingTypeEval
                    ] = evaluations;

                    allSectionStatuses.push({
                        orderId: order.order_id,
                        serialno,
                        Endplate: evaluateSection([
                            lengthEval?.status, heightEval?.status, rowsEval?.status,
                            endplateMaterialEval?.status, endplateModelEval?.status,
                            endplateOrientationEval?.status, coverDetailEval?.status
                        ]),
                        Pipe: evaluateSection([
                            pipeTypeEval?.status, straightPipeEval?.status,
                            singlePipeEval?.status, crossPipeEval?.status,
                            otherPipeEval?.status
                        ]),
                        Fins: evaluateSection([
                            finsPerInchEval?.status, finThicknessEval?.status
                        ]),
                        Assembly: evaluateSection([afterCoilEval?.status]),
                        Brazing: evaluateSection([
                            circuitEval?.status, feedingEval?.status,
                            liquidLineEval?.status, dischargeLineEval?.status,
                            afterBrazingEval?.status
                        ]),
                        Packing: evaluateSection([
                            paintTypeEval?.status, packingTypeEval?.status
                        ])
                    });
                }
            }

            setSectionStatus(allSectionStatuses);
            setOrderList(sortedOrders);


        } catch (error) {
            console.error("Error fetching order list:", error);

        }
    };




    useEffect(() => {
        // handleGetLookup();
        handleOrderList(access);
    }, []);





    // useEffect(() => {
    //         handleOrderList();
    //     }, [lookUpList]);

    const handleGenericUpdate = async (rowid, field, value) => {
        var bodyFormData = new FormData();
        bodyFormData.append("authId", access);
        bodyFormData.append("id", rowid);
        bodyFormData.append(field, value);
        bodyFormData.append("quality_modified_by",localStorage.getItem('authId')?.replace(/[0-9]/g, '') || 'Unknown',)
        axios({
            method: "post",
            url: setOrderGeneric,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                //handle success
                const res_data = response.data;
                if (res_data.status_code === 200) {
                    toast(res_data.status_msg, "success");
                    // handleOrderList(access);
                    if (field.includes("status")) {
                        setAnimeShow(true);
                        const timeId = setTimeout(() => {
                            // After 3 seconds set the show value to false
                            setAnimeShow(false);
                        }, 4000);

                        return () => {
                            clearTimeout(timeId);
                        };
                    }

                    //return data
                } else {
                    toast(res_data.status_msg, "error");
                    return false;
                }
            })
            .catch(function (response) {
                console.log(response)
                //handle error
                   toast.error("error occurs", "error");
            });
    };

    const handleNested = (rowId, e) => {
        const { name, checked } = e.target;


        var idx = orderList.findIndex((item) => item.id === rowId);



        // if (name === "quality_status") {
        //     if (
        //         !moment(orderList.at(idx).quality_status_dt, "YYYY-MM-DD HH:mm:ss").isValid()
        //     ) {
        //         toast("Please check Painting before updating status.", "warning");
        //         return;
        //     }
        // }

        var editData;
        if (name.includes("status")) {
            editData = orderList.filter((itemA) => rowId !== itemA.id);
        } else {
            editData = orderList.map((item) =>
                item.id === rowId && name ? { ...item, [name]: String(checked) } : item
            );
        }

        setOrderList(editData);
        handleGenericUpdate(rowId, name, String(checked));
    };



    const handleClickOpenStatus = (rowId, e) => {
        setSelectedRowId(rowId);
        setSelEvent(e);
        setOpenStatusCnf(true);
    };


    // const [getinspectionList, setInspectionList] = useState([]);


    // useEffect(() => {
    //     const fetchAndGenerate = async () => {
    //         try {
    //             const bodyFormData = new FormData();
    //             bodyFormData.append("authId", access);

    //             // const response = await axios.post(get_inspection_list, bodyFormData);
    //             // const data = response?.data?.data || [];
    //             // setInspectionList(data);
    //         } catch (error) {
    //             console.error("Error fetching inspection list:", error);
    //         }
    //     };

    //     fetchAndGenerate();
    // }, []);  

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [filteredOrderIds, setFilteredOrderIds] = useState([]);



    // const handleCellClick = (params) => {
    //     console.log(params,"params")
    //     const selectedOrderId = params.row.order_id;
    //     console.log(selectedOrderId)

    //     console.log(params.row.serial_no)

    //     setSelectedOrderId(selectedOrderId);
    //     const filteredOrderIds = sectionStatus.filter(item => item.orderId == selectedOrderId);
    //     console.log(filteredOrderIds);



    //     setFilteredOrderIds(filteredOrderIds);
    //     setIsDialogOpen(true);
    // };


    // const handleCellClick = (params) => {
    //     console.log(params, "params");

    //     const selectedOrderIdFull = params.row.order_id; // e.g., "242175E"
    //     const serialNo = params.row.serial_no;     

    //     console.log(selectedOrderIdFull);

    //     // e.g., "1,3" or null/empty

    //     // Extract numeric part from order ID (e.g., "242175")
    //     const numericOrderId = selectedOrderIdFull.replace(/\D+$/, '');

    //     // Filter sectionStatus where orderId matches numeric part
    //     const filtered = sectionStatus.filter(item => item.orderId == numericOrderId);
    //     console.log("Filtered:", filtered);

    //     let matchedItems = [];

    //     if (!serialNo || String(serialNo).trim() === "") {
    //         matchedItems = filtered;
    //     } else {
    //         // Split comma-separated serial numbers into array
    //         const serialNoList = String(serialNo).split(',').map(s => s.trim());

    //         // Filter only matched serial numbers
    //         matchedItems = filtered.filter(item =>
    //             serialNoList.includes(String(item.serialno))
    //         );

    //         console.log(matchedItems);
    //     }

    //     // Replace orderId with full ID (e.g., "242175E")
    //     const updatedItems = matchedItems.map(item => ({
    //         ...item,
    //         orderId: selectedOrderIdFull,
    //     }));

    //     console.log(updatedItems);

    //     setSelectedOrderId(selectedOrderIdFull);
    //     setFilteredOrderIds(updatedItems);
    //     setIsDialogOpen(true);
    // };


    const handleCellClick = (params) => {


        const selectedOrderIdFull = params.row.order_id;
        const serialNo = params.row.serial_no;
        const filtered = sectionStatus.filter(item => item.orderId === selectedOrderIdFull);

        let matchedItems = [];

        if (!serialNo || String(serialNo).trim() === "") {
            matchedItems = filtered;
        } else {
            const serialNoList = String(serialNo).split(',').map(s => s.trim());
            matchedItems = filtered.filter(item =>
                serialNoList.includes(String(item.serialno))
            );
        }

        setSelectedOrderId(selectedOrderIdFull);
        setFilteredOrderIds(matchedItems);
        setIsDialogOpen(true);
    };




    const handleCloseDialog1 = () => {
        setIsDialogOpen(false);
        setSelectedOrderId(null);
    };




    const getSectionResult = (relatedRows, key) => {
        if (relatedRows.length === 0) return '';

        const statuses = relatedRows.map(item => (item[key] || '').toLowerCase());

        if (statuses.some(status => status === 'fail')) {
            return 'Fail';
        }

        if (statuses.every(status => status === 'pass')) {
            return 'Pass';
        }

        return '';
    };


    const columns = [
        {
            field: "order_id",
            headerName: "OrderNo",
            minWidth: 30,
            renderCell: (params) => {
                return (
                    <Button
                        fullWidth
                        onClick={() => {
                            setSelectedRowId(params.row.id);
                            setIsEdit(false);
                            setOpenOrderView(true);
                        }}
                        color="info"
                        className="toolButton-grid "
                    >
                        {params.row.order_id}
                    </Button>
                );
            },
            flex: 1,
        },

        { field: 'full_customer_name', headerName: 'Customer Name', minWidth: 220 },
        {
            field: 'size',
            headerName: 'Size',
            minWidth: 150,
            renderCell: (params) => (
                <Button variant="text" onClick={() => handleOpenDialog(params.row)}>
                    {params.row.size}
                </Button>
            )
        },
        {
            field: "orstatus",
            headerName: "Order Status",
            width: 150,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {

                const imageUrl = params.row.orstatus;

                return imageUrl ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center", // Centers horizontally
                            alignItems: "center", // Centers vertically
                            // height: "100%", // Takes full height of the cell
                            // width: "100%", // Takes full width of the cell
                        }}
                    >
                        <img
                            src={imageUrl}
                            alt="Order Status"
                            style={{
                                maxWidth: "100%",  // Ensures the image scales properly within the cell
                                maxHeight: "80%", // Ensures the image doesn't overflow the cell
                                objectFit: "contain", // Ensures the image maintains its aspect ratio
                            }}
                        />
                    </div>
                ) : null;
            },
        },

        {
            field: 'ordersta',
            headerName: 'Order Check',
            minWidth: 100,
            renderCell: (params) => {

                return (
                    <Button
                        sx={{

                            cursor: 'pointer',
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        onClick={() => handleCellClick(params)}
                    >
                        view status
                    </Button>
                );
            }
        },

        // {
        //     field: 'endplate',
        //     headerName: 'Endplate',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         const isAllEndplatePass = relatedRows.length > 0 &&
        //             relatedRows.every(item => item.Endplate === 'Pass');

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: isAllEndplatePass ? 'green' : 'inherit',
        //                     display: "flex",
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {isAllEndplatePass ? 'Pass' : ''}
        //             </Typography>
        //         );
        //     }
        // },

        // {
        //     field: 'endplate',
        //     headerName: 'Endplate',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         let result = '';

        //         if (relatedRows.length > 0) {
        //             const statuses = relatedRows.map(item => (item.Endplate || '').toLowerCase());

        //             if (statuses.some(status => status === 'fail')) {
        //                 result = 'Fail';
        //             } else if (statuses.every(status => status === 'pass')) {
        //                 result = 'Pass';
        //             }
        //         }

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
        //                     display: 'flex',
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {result}
        //             </Typography>
        //         );
        //     }
        // },

        // {
        //     field: 'pipe',
        //     headerName: 'Pipe',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         const isAllPipePass = relatedRows.length > 0 &&
        //             relatedRows.every(item => item.Pipe === 'Pass');

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: isAllPipePass ? 'green' : 'inherit',
        //                     display: "flex",
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {isAllPipePass ? 'Pass' : ''}
        //             </Typography>
        //         );
        //     }
        // },



        // {
        //     field: 'fins',
        //     headerName: 'Fins',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         const isAllFinsPass = relatedRows.length > 0 &&
        //             relatedRows.every(item => item.Fins === 'Pass');

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: isAllFinsPass ? 'green' : 'inherit',
        //                     display: "flex",
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {isAllFinsPass ? 'Pass' : ''}
        //             </Typography>
        //         );
        //     }
        // },
        // {
        //     field: 'assembly',
        //     headerName: 'Assembly',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         const isAllFinsPass = relatedRows.length > 0 &&
        //             relatedRows.every(item => item.Assembly === 'Pass');

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: isAllFinsPass ? 'green' : 'inherit',
        //                     display: "flex",
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {isAllFinsPass ? 'Pass' : ''}
        //             </Typography>
        //         );
        //     }
        // },

        // {
        //     field: 'brazing',
        //     headerName: 'Brazing',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         const isAllBrazingPass = relatedRows.length > 0 &&
        //             relatedRows.every(item => item.Brazing === 'Pass');

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: isAllBrazingPass ? 'green' : 'inherit',
        //                     display: "flex",
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {isAllBrazingPass ? 'Pass' : ''}
        //             </Typography>
        //         );
        //     }
        // },
        // {
        //     field: 'packing',
        //     headerName: 'Packing',
        //     minWidth: 30,
        //     renderCell: (params) => {
        //         const orderId = params.row.order_id;

        //         const relatedRows = sectionStatus.filter(item => item.orderId === orderId);

        //         const isAllPackingPass = relatedRows.length > 0 &&
        //             relatedRows.every(item => item.Packing === 'Pass');

        //         return (
        //             <Typography
        //                 sx={{
        //                     color: isAllPackingPass ? 'green' : 'inherit',
        //                     display: "flex",
        //                     justifyContent: 'center',
        //                     alignItems: 'center',
        //                     width: '100%',
        //                     textAlign: 'center'
        //                 }}
        //             >
        //                 {isAllPackingPass ? 'Pass' : ''}
        //             </Typography>
        //         );
        //     }
        // },

        {
            field: 'endplate',
            headerName: 'Endplate',
            minWidth: 30,
            renderCell: (params) => {
                const orderId = params.row.order_id;
                const relatedRows = sectionStatus.filter(item => item.orderId === orderId);
                const result = getSectionResult(relatedRows, 'Endplate');

                return (
                    <Typography
                        sx={{
                            color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        {result}
                    </Typography>
                );
            }
        },
        {
            field: 'pipe',
            headerName: 'Pipe',
            minWidth: 30,
            renderCell: (params) => {
                const orderId = params.row.order_id;
                const relatedRows = sectionStatus.filter(item => item.orderId === orderId);
                const result = getSectionResult(relatedRows, 'Pipe');

                return (
                    <Typography
                        sx={{
                            color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        {result}
                    </Typography>
                );
            }
        },
        {
            field: 'fins',
            headerName: 'Fins',
            minWidth: 30,
            renderCell: (params) => {
                const orderId = params.row.order_id;
                const relatedRows = sectionStatus.filter(item => item.orderId === orderId);
                const result = getSectionResult(relatedRows, 'Fins');

                return (
                    <Typography
                        sx={{
                            color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        {result}
                    </Typography>
                );
            }
        },
        {
            field: 'assembly',
            headerName: 'Assembly',
            minWidth: 30,
            renderCell: (params) => {
                const orderId = params.row.order_id;
                const relatedRows = sectionStatus.filter(item => item.orderId === orderId);
                const result = getSectionResult(relatedRows, 'Assembly');

                return (
                    <Typography
                        sx={{
                            color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        {result}
                    </Typography>
                );
            }
        },
        {
            field: 'brazing',
            headerName: 'Brazing',
            minWidth: 30,
            renderCell: (params) => {
                const orderId = params.row.order_id;
                const relatedRows = sectionStatus.filter(item => item.orderId === orderId);
                const result = getSectionResult(relatedRows, 'Brazing');

                return (
                    <Typography
                        sx={{
                            color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        {result}
                    </Typography>
                );
            }
        },
        {
            field: 'packing',
            headerName: 'Packing',
            minWidth: 30,
            renderCell: (params) => {
                const orderId = params.row.order_id;
                const relatedRows = sectionStatus.filter(item => item.orderId === orderId);
                const result = getSectionResult(relatedRows, 'Packing');

                return (
                    <Typography
                        sx={{
                            color: result === 'Pass' ? 'green' : result === 'Fail' ? 'red' : 'inherit',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        {result}
                    </Typography>
                );
            }
        },


        {
            field: "quality_status",
            headerName: "Status",
            renderCell: (params) => {
                return (
                    <IOSSwitch
                        checked={params.row.quality_status === "true"}
                        sx={{ m: 1 }}
                        name="quality_status"
                        onChange={(e) => {
                            const orderId = params.row.order_id;
                            const status = sectionStatus.find(item => item.orderId === orderId);

                            const allSectionsPassed = status &&
                                status.Endplate == "Pass" &&
                                status.Pipe == "Pass" &&
                                status.Fins == "Pass" &&
                                status.Assembly == "Pass" &&
                                status.Brazing == "Pass" &&
                                status.Packing == "Pass";


                            if (allSectionsPassed) {

                                handleClickOpenStatus(params.row.id, e);
                            } else {
                                toast.error("All Module must Be Pass To  Move the Dispatch Module.")
                            }
                        }}
                    />

                );
            },
            maxWidth: 70,
            flex: 1,
        },
    ];


    const [open, setOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleOpenDialog = (rowData) => {
        const orientation = handleFindLookup_arr(lookUpList, "oreientation", rowData.end_plate_orientation);
        const coverDetail = handleFindCoverDetailLookup_arr(lookUpList, rowData.cover_detail);

        const liquid = handleFindLookup_arr(
            lookUpList,
            "liquidLine",
            rowData.liquid_line
        );

        const discharge = handleFindLookup_arr(
            lookUpList,
            "dischargeLine",
            rowData.discharge_line
        );
        const paintt = handleFindLookup_arr(
            lookUpList,
            "paintType",
            rowData.paint
        );

        const packing = handleFindLookup_arr(
            lookUpList,
            "packingType",
            rowData.packing_type
        );

        const updatedRowData = {
            ...rowData,
            orientation,
            coverDetail,
            liquid,
            discharge,
            paintt,
            packing
        };

        setSelectedRow(updatedRowData);
        setOpen(true);
    };


    const handleCloseDialog = () => {
        setOpen(false);
        handleOrderList();
        setSelectedRow(null);
    };


    const handleCloseModal = (response) => {
        setOpenOrderView(false);
    };



    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    function CustomToolbar({ rows, columns }) {



        const handlePrint = () => {

            const titleHTML = '<h2 style="text-align: center;">Quality</h2>';
            const startIndex = currentPage * rowsPerPage;
            const endIndex = startIndex + rowsPerPage;
            const rowsToPrint = rows.slice(startIndex, endIndex);


            // Debugging
            const columnWidths = {
                "order_id": 2,
                "full_customer_name": 20,
                "size": 15,

            };
            const allowedColumns = ["quality_status"];
            let tableHTML = '<table style="width:100%; border-collapse: collapse;">';
            tableHTML += '<thead><tr>';
            columns
                .filter(col => !allowedColumns.includes(col.field))
                .forEach((col) => {
                    const width = columnWidths[col.field] || 'auto';
                    tableHTML += `<th style="border: 1px solid #ddd; padding: 8px;width: ${width}%;">${col.headerName}</th>`;
                });
            tableHTML += '</tr></thead><tbody>';

            const firstStateFields = ['order_id', 'full_customer_name', 'size'];

            rowsToPrint.forEach((row) => {



                const orderId = row.order_id;
                const status = sectionStatus.find(item => item.orderId === orderId) || {};


                tableHTML += '<tr>';

                columns
                    .filter(col => !allowedColumns.includes(col.field))
                    .forEach((col) => {
                        let cellValue;



                        if (firstStateFields.includes(col.field)) {
                            // Get value from main row state
                            cellValue = row[col.field] || 'N/A';
                        }
                        else {
                            const normalizedStatus = Object.fromEntries(
                                Object.entries(status || {}).map(([key, value]) => [key.toLowerCase(), value])
                            );

                            cellValue = normalizedStatus[col.field.toLowerCase()] || 'N/A';

                        }

                        tableHTML += `<td style="border: 1px solid #ddd; padding: 8px;">${cellValue}</td>`;
                    });

                tableHTML += '</tr>';
            });




            tableHTML += '</tbody></table>';

            const iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = 'none';
            document.body.appendChild(iframe);

            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write('<html><head><title>Print DataGrid</title>');
            doc.write('<style>table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }</style>');
            doc.write('</head><body>');
            doc.write(titleHTML);
            doc.write(tableHTML);
            doc.write('</body></html>');
            doc.close();


            iframe.contentWindow.focus();
            iframe.contentWindow.print();

            document.body.removeChild(iframe)
        };

        const exportToCsv = () => {
            const allColumns = columns;

            // Merge sectionStatus into each row
            const mergedRows = rows.map((row) => {
                const status = sectionStatus.find(item => item.orderId === row.order_id) || {};
                return {
                    ...row,
                    ...Object.fromEntries(
                        Object.entries(status).map(([key, val]) => [key.toLowerCase(), val])
                    )
                };
            });



            const excludedFields = ["quality_status", "ordersta", "orstatus"];

            // Filter out rows with N/A values
            const visibleRows = mergedRows.filter(row => {
                return !Object.values(row).includes("N/A");
            });

            // Create CSV header
            const header = allColumns
                .filter(col => !excludedFields.includes(col.field))
                .map(col => col.headerName)
                .join(",");

            // Create CSV rows
            const csvRows = visibleRows.map(row =>
                allColumns
                    .filter(col => !excludedFields.includes(col.field))
                    .map(col => {
                        let val = row[col.field.toLowerCase()] || row[col.field] || "";
                        return `"${val}"`;
                    })
                    .join(",")
            );

            // Combine header + rows
            const csvData = [header, ...csvRows];
            const csvString = csvData.join("\n");

            // Trigger download
            const blob = new Blob([csvString], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Quality.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };

        const formatDate = (dateStr) => {
            if (!dateStr) return "";
            const date = new Date(dateStr.replace(" ", "T")); // ensures valid Date parsing
            if (isNaN(date)) return dateStr; // fallback if invalid

            const day = date.getDate().toString().padStart(2, "0");
            const month = date.toLocaleString("en-US", { month: "short" }); // use "long" for full month

            return `${day}-${month}`; // e.g., "18-Apr"
        };



        const exportToCsv1 = async () => {
            try {
 
                const bodyFormData = new FormData();
                bodyFormData.append("authId", access);
 
                const response = await axios.post(order_issue_list, bodyFormData, {
                    headers: { "Content-Type": "multipart/form-data" }
                });

                const rows = response.data?.data || [];

                if (rows.length === 0) {
                    toast("No data available to export", { type: "warning" });
                    return;
                }

                // Define custom column headers
                const customHeaders = {
                    id: "ID",
                    order_id: "Order No",
                    order_size:"Size",
                    customer_name :"Customer Name",
                    created_date: "Created Date",
                    order_serial_no:"Coil No",
                    issue_section: "Issue Section",
                    modified_by: "Checked By",
                    issue_detail: "Issue Detail",
                    remarks: "Remarks",
                };

                // Build header row
                const header = Object.values(customHeaders).join(",");

                // Build CSV data rows
                const csvRows = rows.map(row =>
                    Object.keys(customHeaders).map(key => {
                        let value = row[key] || "";

                        // Format date if key is 'created_date'
                        if (key === 'created_date') {
                            value = formatDate(value);
                        }

                        return `"${value.toString().replace(/"/g, '""')}"`;
                    }).join(",")
                );


                // Combine header + data rows
                const csvData = [header, ...csvRows].join("\n");

                // Trigger CSV file download
                const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Order_Issue_List.csv";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url); // Clean up

            } catch (error) {
                console.error("Error exporting CSV:", error);
                toast("Failed to export CSV", { type: "error" });
            }
        };







        return (
            <GridToolbarContainer sx={{ margintop: '5px' }}>
                <GridToolbar printOptions={{ disableToolbarButton: true }} // Enable Print
                    csvOptions={{ disableToolbarButton: false }}
                    excelOptions={{ disableToolbarButton: true }} />
                {/* <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }} // Enable Print
                    csvOptions={{ disableToolbarButton: false }}
                    excelOptions={{ disableToolbarButton: true }}
                /> */}
                <Button onClick={handlePrint} startIcon={<PrintIcon />}>
                    Print
                </Button>
                <Button onClick={exportToCsv}>
                    Export to CSV
                </Button>
                <Button onClick={exportToCsv1} startIcon={<FileDownloadIcon/>}>
                    Export issues
                </Button>
            </GridToolbarContainer>
        );
    }

    const refreshData = (request) => {
        if (request) {
            handleOrderList(access);
        }
    };





    const handleDelete = async (serialnoToDelete, orderId) => {
        const pureOrderId = orderId.replace(/[^\d]/g, '');
        const bodyFormData = new FormData();
        bodyFormData.append("authId", access);
        bodyFormData.append("order_serial_no", serialnoToDelete);
        bodyFormData.append("order_id", pureOrderId);

        try {
            const response = await axiosInstances({
                method: "post",
                url: inspection_order_delete,
                data: bodyFormData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            const res_data = response.data;
            setFilteredOrderIds(prev =>
                prev.filter(order =>
                    !(order.serialno === serialnoToDelete && order.orderId === orderId)
                )
            );

            handleOrderList();
            toast.success("Deleted successfully!");
        } catch (error) {
            console.error("Error deleting order:", error);
            toast.error("Error deleting order.");
        }
    };



    const [openDialog, setOpenDialog] = useState(false);
    const [selectedDeleteInfo, setSelectedDeleteInfo] = useState({
        serialno: null,
        orderId: null,
    });


    return (
        <Box style={{ marginTop: "105px", width: "100%" }} >

            <ToastContainer />
            {/* <TickGif show={animeShow } /> */}
            <Card className="nestingres">
                <CardContent>
                    <Stack direction={"row"} sx={{ flexWrap: 'wrap', gap: 3 }}>
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            sx={{
                                "& .MuiTypography-root": {
                                    width: "350px",
                                },
                            }}
                            className="mt-2"
                        >
                            Quality
                        </Typography>

                        <ModuleTools
                            pageName="quality"
                            OrderData={orderList}
                            refreshPage={(request) => refreshData(request)}
                        />
                        <div style={{ border: "1px solid grey" }}></div>

                        {accessModuleList.filter((x) => x.module_name === "Quality")[0]
                            .access_rw === "1" && (
                                <NavLink to="/paintingpacking" className="toolButton">
                                    <KeyboardDoubleArrowLeftIcon style={{ color: "#BC1921" }} />
                                    Prev Module
                                </NavLink>
                            )}
                        {accessModuleList.filter((x) => x.module_name === "Quality")[0]
                            .access_rw === "1" && (
                                <NavLink to="/dispatch" className="toolButton">
                                    Next Module
                                    <KeyboardDoubleArrowRightIcon style={{ color: "#BC1921" }} />
                                </NavLink>
                            )}
                    </Stack>
                    <div className="mt-3">
                        <DataGrid
                            // slots={{ toolbar: GridToolbar }}
                            slots={{
                                toolbar: () => <CustomToolbar rows={orderList} columns={columns} />
                            }}

                            getRowClassName={(params) =>
                            // params.indexRelativeToCurrentPage % 2 === 0
                            // 	? "Mui-even"
                            // 	: "Mui-odd"

                            {
                                if (params.indexRelativeToCurrentPage % 2 === 0) {
                                    if (params.row.priority === "true" && params.row.quality != "1") {
                                        return "secon-bg";
                                    } else if (
                                        params.row.tcutting_status === "true" &&
                                        params.row.finpunch_status === "true" &&
                                        params.row.quality != 0 && params.row.quality != null
                                    ) {
                                        return "quality-check";
                                    }
                                    else if (
                                        params.row.priority === "true" && params.row.quality == "1"
                                    ) {
                                        return "quality-check";
                                    }
                                    else {
                                        return "Mui-even";
                                    }
                                } else {
                                    if (params.row.priority === "true" && params.row.quality != "1") {
                                        return "secon-bg";
                                    } else if (
                                        params.row.tcutting_status === "true" &&
                                        params.row.finpunch_status === "true" &&
                                        params.row.quality != "0" && params.row.quality != null
                                    ) {
                                        return "quality-check";
                                    } else if (
                                        params.row.priority === "true" && params.row.quality == "1"
                                    ) {
                                        return "quality-check";
                                    }
                                    else {
                                        return "Mui-odd";
                                    }
                                }

                            }
                            }

                            sx={{
                                "& .MuiDataGrid-root": {
                                    width: "100% !important",
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    backgroundColor: "#943612",
                                    color: "white",
                                },
                                ".MuiDataGrid-row.Mui-odd": {
                                    backgroundColor: "#FFE1D6",
                                },
                                ".MuiDataGrid-row.Mui-even": {
                                    backgroundColor: "#F2F2F2",
                                },

                                ".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell":
                                {
                                    whiteSpace: "break-spaces",
                                    padding: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                    fontSize: "0.75rem",
                                },

                                ".MuiDataGrid-columnHeaderTitleContainer": {
                                    display: "flex",
                                    justifyContent: "center",
                                    fontSize: "0.75rem",
                                },

                                "& .MuiDataGrid-cell.MuiDataGrid-cell ": {
                                    border: ".5px solid white !important",
                                },

                                "& .MuiInputBase-input": {
                                    fontSize: "0.74rem",
                                    padding: "16.5px 1px",
                                },

                            }}

                            onProcessRowUpdateError={(param) => {
                                console.log(param);
                            }}

                            onPaginationModelChange={(model) => {
                                setCurrentPage(model.page);
                                setRowsPerPage(model.pageSize);
                            }}

                            rowHeight={50}
                            // columns={columns}
                            columns={columns.map((data) => ({
                                ...data,
                                ...(data.field === 'order_id'
                                    ? { width: 30 }
                                    : {
                                        flex: 1,
                                        // rowSpanValueGetter: (value, row) => {
                                        //     console.log(value)
                                        //     console.log(row)
                                        //     console.log(data.field)
                                        //     return data.field === 'section' || data.field === 'finalStatus'
                                        //         ? value
                                        //         : row
                                        //             ? `${row.section}-${row.finalStatus}-${row.id}`
                                        //             : value;
                                        // },
                                    }),

                            }))}
                            rows={orderList}
                            editMode="cell"
                        />
                    </div>
                </CardContent>
            </Card>

            <Dialog
                fullWidth={true}
                maxWidth={"lg"}
                open={openOrderView}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpenOrderView(false)}
                key={Math.random(1, 100)}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    View Order Details
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleCloseModal}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    id="order-view-close-btn"
                >
                    <CloseIcon />
                </IconButton>
                <OrderViewModal orderId={selectedRowId} key={Math.random(1, 100)} />
            </Dialog>

            <Dialog
                open={openStatusCnf}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseStatus}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    {"Do you want to mark the status complete of the order?"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => handleCloseStatus("no")}>No</Button>
                    <Button onClick={() => handleCloseStatus("yes")}>Yes</Button>
                </DialogActions>
            </Dialog>


            <Dialog open={open} onClose={handleCloseDialog} maxWidth="xxl">
                <DialogTitle>Size Component</DialogTitle>
                <DialogContent>
                    <QualityInspectionReport selectedRow={selectedRow} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Close</Button>
                </DialogActions>
            </Dialog>


            <Dialog open={isDialogOpen} onClose={handleCloseDialog1} maxWidth="xl">

                <DialogContent>
                    <Typography variant="h6">Order ID: {selectedOrderId}</Typography>

                    {filteredOrderIds.length > 0 ? (
                        <Table>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#C5552C', color: "white" /* or any color you like */ }}>
                                    <TableCell style={{ color: 'white' }}><strong>Quality No</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Endplate</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Pipe</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Fins</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Assembly</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Brazing</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Packing</strong></TableCell>
                                    <TableCell style={{ color: 'white' }}><strong>Action</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredOrderIds.map((order, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{ border: '1px solid black' }}>{order.serialno}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>{order.Endplate}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>{order.Pipe}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>{order.Fins}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>{order.Assembly}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>{order.Brazing}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>{order.Packing}</TableCell>
                                        <TableCell style={{ border: '1px solid black' }}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={() => {
                                                    setSelectedDeleteInfo({
                                                        serialno: order.serialno,
                                                        orderId: order.orderId, // replace with your actual field
                                                    });
                                                    setOpenDialog(true);
                                                }}
                                            >
                                                Delete
                                            </Button>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography variant="body1">No details available for this Order ID.</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleCloseDialog1}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete Coil <strong>{selectedDeleteInfo.serialno}</strong> from Order <strong>{selectedDeleteInfo.orderId}</strong>?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            handleDelete(selectedDeleteInfo.serialno, selectedDeleteInfo.orderId);
                            setOpenDialog(false);
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>



        </Box>
    );
}

export default Quality;